import { ValidatorFn } from '@angular/forms';
import { IOption } from '../Models';

export class QuestionBase<T> {
    value: T|undefined;
    key: string;
    label: string;
    required: boolean;
    optionalLabel: boolean;
    currency: boolean;
    multiple: boolean;
    order: number;
    controlType: string;
    type: string;
    placeholder: string;
    minlength?: number;
    maxlength?: number;
    options: IOption[];
    validators?: ValidatorFn[];
    errorMessages?: { [key: string]: string };

    constructor(options: {
        value?: T;
        key?: string;
        label?: string;
        required?: boolean;
        optionalLabel?: boolean;
        currency?: boolean;
        multiple?: boolean;
        order?: number;
        controlType?: string;
        type?: string;
        placeholder?: string;
        minlength?: number;
        maxlength?: number;
        options?: IOption[];
        validators?: ValidatorFn[];
        errorMessages?: { [key: string]: string };
      } = {}) {
      this.value = options.value;
      this.key = options.key || '';
      this.label = options.label || '';
      this.required = !!options.required;
      this.optionalLabel = !!options.optionalLabel;
      this.currency = !!options.currency;
      this.multiple = !!options.multiple;
      this.order = options.order === undefined ? 1 : options.order;
      this.controlType = options.controlType || '';
      this.type = options.type || '';
      this.placeholder = options.placeholder || '';
      this.minlength = options.minlength;
      this.maxlength = options.maxlength;
      this.options = options.options || [];
      this.validators = options.validators || [];
      this.errorMessages = options.errorMessages || {};
    }
  }
